export default __webpack_public_path__ + "static/media/logo-gruas.5cb2c65b.png";